import type { FieldAccessor } from './types';

/** A row's value by dot path or accessor; null when absent or the accessor throws. */
export function getValue<T>(row: T, field: FieldAccessor<T> | undefined): unknown {
  if (!field) {
    return null;
  }
  if (typeof field === 'function') {
    try {
      return field(row);
    } catch {
      return null;
    }
  }
  let value: unknown = row;
  for (const part of field.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') {
      return null;
    }
    value = (value as Record<string, unknown>)[part];
  }
  return value ?? null;
}
